import { useState } from 'react';

/**
 * Custom hooks to wrap functions that perform asynchronous processing and manage loading state
 * @param callback
 * @returns
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useAsyncHandler<T extends any[], R = void>(callback: (...args: T) => Promise<R>) {
  const [loading, setLoading] = useState(false);

  const execute = async (...args: T): Promise<R> => {
    setLoading(true);
    try {
      const result = await callback(...args);
      return result;
    } finally {
      setLoading(false);
    }
  };

  return { loading, execute };
}
